import React, { Fragment, useState } from "react";
import { Card, CardBody, Row, Col, Progress, CardHeader, Table, Badge } from "reactstrap";
import { formattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { LoadingMessage, GetRiskClassName } from "./helper";
import style from "./styles.module.scss";


const PopUp = ({ text, onClose }) => (
  <div className={style.popUp}>
    <span>{text}</span>
    <button onClick={onClose} className={style.closeButton}>×</button>
  </div>
);

export const PersonRiskTable = ({ person, riskSummary, riskByPersonIsEnabled, onboarding }) => {
  const [popUp, setPopUp] = useState(null);
  const togglePopUp = (index, text) => {
    setPopUp(popUp && popUp.index === index ? null : { index, text });
  };

  return (
    <Row className={style.risk}>
      <Col lg="12">
        {!person ? (
          <LoadingMessage text="Loading person info" />
        ) : (
          <Fragment>
            {riskByPersonIsEnabled && (
              <div>
                <Card className="mt-1 mb-3">
                  <CardHeader className="pt-2 pb-2">Risk</CardHeader>
                  <CardBody>
                    <Row>
                      <Col lg="9">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Factor description</th>
                              <th className="text-right">Factor Weight</th>
                              <th className="text-right">Data</th>
                              <th className="text-right">Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            <LoadingOrEmpty
                              isLoading={!riskSummary}
                              isEmpty={riskSummary && riskSummary.Risk.length == 0}
                            >
                              {riskSummary &&
                                riskSummary.Risk.map((risk) => (
                                  <tr key={`factor-${risk.FactorId}`}>
                                    <td className={style.title}>{risk.FactorDescription}</td>
                                    <td className="text-right">{risk.FactorWeight}</td>
                                    <td className="text-right">{risk.Data}</td>
                                    <td className="text-right">{Number.parseInt(risk.Score)}</td>
                                  </tr>
                                ))}
                            </LoadingOrEmpty>
                          </tbody>
                        </Table>
                      </Col>
                      <Col lg="3">
                        <RiskSummary person={person} riskSummary={riskSummary} />
                      </Col>
                    </Row>
                    {riskSummary && riskSummary.Risk.length != 0 && (
                      <Row>
                        <Col sm="9">
                          <div className="pt-3 pl-2 pr-2">
                            <h6>
                              <span className="float-right d-block text-primary ">
                                Total {getTotalRiskScore(riskSummary)} points
                              </span>
                            </h6>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader className="pt-2 pb-2">Profile Risk</CardHeader>
                  <CardBody>
                    <Row>
                      <Col lg="9">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Question</th>
                              <th>Answer</th>
                              <th className="text-right">Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            <LoadingOrEmpty
                              isLoading={!riskSummary}
                              isEmpty={riskSummary && riskSummary.ProfileRisk.length == 0}
                            >
                              {riskSummary &&
                                riskSummary.ProfileRisk.map((risk) => (
                                  <tr key={`factor-${risk.QuestionId}`}>
                                    <td className={style.title}>{risk.QuestionDescription}</td>
                                    <td>{risk.AnswerDescription}</td>
                                    <td className="text-right">{risk.AnswerScore}</td>
                                  </tr>
                                ))}
                            </LoadingOrEmpty>
                          </tbody>
                        </Table>
                      </Col>
                      {riskSummary && person && (
                        <Col lg="3">
                          <ProfileRiskSummary person={person} riskSummary={riskSummary} />
                        </Col>
                      )}
                    </Row>
                    {riskSummary && riskSummary.ProfileRisk.length != 0 && (
                      <Row>
                        <Col sm="9">
                          <div className="pt-3 pl-2 pr-2">
                            <h6>
                              {riskSummary.PersonProfileRisk}
                              <span className="float-right d-block text-primary ">
                                Total {getTotalScore(riskSummary)} points
                              </span>
                            </h6>
                            <Progress
                              className={style.progress}
                              value={riskSummary.ProfileRiskPercentage}
                              max="100"
                            />
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
                <Card className="mt-1 mb-3">
                  <CardHeader className="pt-2 pb-2">Transactional Limit</CardHeader>
                  <CardBody>
                    <Row>
                      <Col lg="9">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Factor description</th>
                              <th className="text-right">Factor Weight</th>
                              <th className="text-right">Data</th>
                              <th className="text-right">Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            <LoadingOrEmpty
                              isLoading={!riskSummary}
                              isEmpty={riskSummary && riskSummary.TransactionalLimit.length == 0}
                            >
                              {riskSummary &&
                                riskSummary.TransactionalLimit.map((risk) => (
                                  <tr key={`factor-${risk.FactorId}`}>
                                    <td className={style.title}>{risk.FactorDescription}</td>
                                    <td className="text-right">{risk.FactorWeight}</td>
                                    <td className="text-right">{risk.Data}</td>
                                    <td className="text-right">{formattedNumber(risk.Score, "currency", 0)}</td>
                                  </tr>
                                ))}
                            </LoadingOrEmpty>
                          </tbody>
                        </Table>
                      </Col>
                      {/* <Col lg="3">
                        <RiskSummary person={person} riskSummary={riskSummary} />
                      </Col> */}
                    </Row>
                    {/* {riskSummary && riskSummary.TotalTransactionalLimit && ( */}
                    <Row>
                      <Col sm="3">
                        <div className="pt-3 pl-2 pr-2">
                          <h6>
                            <span className="float-right d-block text-primary ">
                              Total {formattedNumber(riskSummary.TotalTransactionalLimit, "currency", 0)}
                            </span>
                          </h6>
                        </div>
                      </Col>
                    </Row>
                    {/* )} */}
                  </CardBody>
                </Card>
              </div>
            )}
            {riskSummary && onboarding && (
              <Card className="mt-1 mb-3">
                <CardHeader className="pt-2 pb-2">List Check Errors</CardHeader>
                <CardBody>
                  <Row>
                    <Col lg="9">
                      {riskSummary.ListCheckErrors ? (
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>List</th>
                              <th className="text-right">Coincidence name</th>
                              <th className="text-right">Coincidence External Id</th>
                              <th className="text-right">Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {riskSummary.ListCheckErrors.map((item, index) => (
                              <tr key={index}>
                                <td>{item.listName}</td>
                                <td className="text-right">{item.personCheckName}</td>
                                <td className="text-right">{item.ListCheckPersonKey}</td>
                                <td className="text-right">
                                  {item.comments ? (
                                    <Fragment>
                                      <i
                                        className="fa fa-info-circle"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => togglePopUp(index, item.comments)}
                                      ></i>
                                      {popUp && popUp.index === index && (
                                        <PopUp text={popUp.text} onClose={() => setPopUp(null)} />
                                      )}
                                    </Fragment>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        <div className="pt-3 pl-2 pr-2">
                          <h6>
                            <span className="float-center d-block text-primary ">No coincidences</span>
                          </h6>
                        </div>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </Fragment>
        )}
      </Col>
    </Row>
  );
};

const RiskSummary = ({ person, riskSummary }) => (
  <div className={style.riskSummary}>
    <p className="h5 mb-2">Summary</p>
    <p>Check every 1 day</p>
    <p>Last check Yesterday</p>
    <p>
      <Badge color="secondary">{riskSummary.BOLevel}</Badge> Level to BO
    </p>
    {/* {person.PersonWayOfAction != "" && (
      <p>
        <Badge color="secondary">{person.PersonWayOfAction} structure</Badge>
      </p>
    )} */}
    <p>
      Risk{" "}
      <Badge
        //color={GetRiskClassName(riskSummary.PersonRisk)}
        className={style.badge}
      >
        {person.PersonRisk}
      </Badge>
    </p>
  </div>
);

const ProfileRiskSummary = ({ person, riskSummary }) => (
  <div className={style.profileRiskSummary}>
    <p className="h5 mb-2">Summary</p>
    {/* <span className={style.riskWarning} id="warning-risk">
      {person.PersonProfileRiskMismatch && (
        <Fragment>
          <i className="fa fa-exclamation-triangle mr-2" aria-hidden="true" />
          Profile mismatch warning
        </Fragment>
      )}
    </span> */}
    <table>
      <thead />
      <tbody>
        <tr>
          <td>Profile risk</td>
          <td>
            <Badge
              //color={GetRiskClassName(riskSummary.PersonProfileRisk)}
              className={style.badge}
            >
              {person.PersonProfileRiskName}
            </Badge>
          </td>
        </tr>
        {/* <tr>
          <td>Current risk</td>
          <td>
            <FormattedNumber
              value={person.PersonCurrentProfileRiskPercentage}
            />
            %
          </td>
          <td>
            <Badge
              color={GetRiskClassName(person.PersonCurrentProfileRisk)}
              className={style.badge}
            >
              {person.PersonCurrentProfileRisk}
            </Badge>
          </td>
        </tr> */}
      </tbody>
    </table>
  </div>
);

const LoadingOrEmpty = ({ isLoading, isEmpty, children }) =>
  isLoading ? (
    <tr>
      <td colSpan="5" className="pl-2 pt-3 pb-3">
        <LoadingMessage className={style.loading} text="Retrieving risk info" />
      </td>
    </tr>
  ) : isEmpty ? (
    <tr>
      <td colSpan="5" className="pl-2 pt-3 pb-3">
        <h5 className={style.loading} style={{ textAlign: "center" }}>
          No risk info registerd
        </h5>{" "}
      </td>
    </tr>
  ) : (
    children
  );

const getTotalScore = (riskSummary) =>
  riskSummary && riskSummary.ProfileRisk.reduce((sum, e) => (sum += parseInt(e.AnswerScore, 10)), 0);

const getTotalRiskScore = (riskSummary) =>
  riskSummary && riskSummary.Risk.reduce((sum, e) => (sum += parseInt(e.Score, 10)), 0);

export default PersonRiskTable;
